module.exports = __webpack_public_path__ + "img/add_btn_icon461.7d6f7835.svg";